var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03125 0C3.63719 0 0 3.57469 0 7.96875C0 12.3628 3.63719 16 8.03125 16C12.4253 16 16 12.3628 16 7.96875C16 3.57469 12.4253 0 8.03125 0ZM12.25 8.90625H8.96875V12.25C8.96875 12.7669 8.54781 13.1875 8.03125 13.1875C7.51437 13.1875 7.09375 12.7669 7.09375 12.25V8.90625H3.75C3.23312 8.90625 2.8125 8.48563 2.8125 7.96875C2.8125 7.45187 3.23312 7.03125 3.75 7.03125H7.09375V3.75C7.09375 3.23312 7.51437 2.8125 8.03125 2.8125C8.54781 2.8125 8.96875 3.23312 8.96875 3.75V7.03125H12.25C12.7666 7.03125 13.1875 7.45187 13.1875 7.96875C13.1875 8.48563 12.7666 8.90625 12.25 8.90625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6cb1c7b0dfe85fd8feec4f6fda7e4f01.svg";
export { ForwardRef as ReactComponent };